module.exports = __webpack_public_path__ + "static/media/blue-green.84b081d6.png";